var map = {
	"./400.svg": "7f38",
	"./CHOCOSWAMP.svg": "f71b",
	"./MABCO.svg": "a274",
	"./SAMATEL.svg": "fa8d",
	"./adidas.svg": "e45e",
	"./box.svg": "64f0",
	"./daboul.svg": "d9d6",
	"./diamond_smile.svg": "c65a",
	"./dmc.svg": "49f3",
	"./hadara.svg": "9028",
	"./icon.svg": "12aa",
	"./logistics-truck.svg": "3c10",
	"./sharp.svg": "8b34",
	"./shibly.svg": "455a",
	"./vita.svg": "88dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";